import React from 'react';
import { ThemeTypes } from 'store/modules/juridico_facil_store/types';
import createTrack from 'services/actions/tracker_actions';

interface FilterJuridicoProps {
  description: string;
  lists: Array<ThemeTypes>;
  url: string;
}

const FilterJuridico = (props: FilterJuridicoProps) => {
  const { description, lists, url } = props;

  return (
    <div className="card mb-2">
      <div className="card-header">{description}</div>
      <ul className="list-group list-group-flush pt-2 pb-1">
        {lists?.map((list) => (
          <li
            className="list-group-item text-secondary border-0 pb-1 pt-0 d-flex align-items-start"
            style={{ fontSize: '13px' }}
          >
            <button
              type="button"
              className="btn btn-link btn-sm p-0 text-left"
              style={{ whiteSpace: 'normal' }}
              onClick={(event) => {
                event.preventDefault();
                createTrack('Jurídico Fácil - Listou uma Temas no acervo');
                window.location.href = `${url}${list?.area_id ? list?.area_id : list?.tema_id}`;
              }}
            >
              {list?.descricao}
            </button>
            <span className="badge badge-primary ml-2 flex-shrink-0">
              {list?.qnt || list?.total}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilterJuridico;
